module.exports = __webpack_public_path__ + "static/media/20161251436352-46.073947fd.jpg";